import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface orderState {
	isLoading: boolean;
	orderList: any;
	totalOrder: number;
	orderDetail: any;
}

const initialState: orderState = {
	isLoading: false,
	orderList: [],
	totalOrder: 0,
	orderDetail: {}
};

const orderSlice = createSlice({
	name: 'OrderSlice',
	initialState,
	reducers: {
		getAllorderInIt: state => {
			state.isLoading = true;
			state.orderList = [];
			state.totalOrder = 0;
		},
		getAllorderSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.totalOrder = data.count;
			state.orderList = [...data.orders];
		},
		getAllorderError: state => {
			state.isLoading = false;
			state.orderList = [];
			state.totalOrder = 0;
		},
		getOrderByIdInIt: state => {
			state.isLoading = true;
		},
		getOrderByIdSuccess: (state, action: PayloadAction<any>) => {
			const data = action.payload.data;
			state.isLoading = false;
			state.orderDetail = { ...data?.orderDetails };
		},
		getOrderByIdError: state => {
			state.isLoading = false;
			state.orderDetail = {};
		},
		clearOrderDetail: state => {
			state.orderDetail = {};
		},
		deleteOrderInIt: state => {
			state.isLoading = true;
		},
		deleteOrderSuccess: state => {
			state.isLoading = false;
			state.orderDetail = {};
		},
		deleteOrderError: state => {
			state.isLoading = false;
		},
		loadingInIt: state => {
			state.isLoading = true;
		},
		loadingSuccess: state => {
			state.isLoading = false;
		},
		loadingError: state => {
			state.isLoading = false;
		}
	}
});

export const {
	getAllorderError,
	getAllorderInIt,
	getAllorderSuccess,
	clearOrderDetail,
	getOrderByIdError,
	getOrderByIdInIt,
	getOrderByIdSuccess,
	deleteOrderError,
	deleteOrderInIt,
	deleteOrderSuccess,
	loadingError,
	loadingInIt,
	loadingSuccess
} = orderSlice.actions;

export default orderSlice.reducer;
